export interface IBackupViewData {
    id: string;
    name: string;
    size: string;
    date: string;
    time: string;
    status: string;
    dateTime: string;
    service: number;
}

export default class BackupViewData implements IBackupViewData {
    id: string;
    name: string;
    size: string;
    date: string;
    time: string;
    status: string;
    dateTime: string;
    service: number;

    constructor(id: string, name: string, size: string, date: string, time: string, status: string, dateTime: string, service: number) {
        this.id = id;
        this.name = name;
        this.size = size;
        this.date = date;
        this.time = time;
        this.status = status;
        this.dateTime = dateTime;
        this.service = service;
    }
} 

const defaultBackupData = new BackupViewData("", "","", "", "", "", "", 0);
export {defaultBackupData};